import "react/jsx-runtime";
import { typography } from "../../../themes/typography/typography.js";
import "color-alpha";
import "@mui/material";
import "../../../themes/external-theme/external-theme.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../constants/colors/palette.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
const root = (theme) => ({
  py: 12,
  color: theme.palette.grey[800],
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    textAlign: "left",
    py: 3
  }
});
const container = (theme) => ({
  maxWidth: "1440px",
  mx: 4.5,
  [theme.breakpoints.down("md")]: {
    mx: 3
  }
});
const sectionTitle = (theme) => ({
  ...typography["DM Serif H2"],
  mb: 2,
  [theme.breakpoints.down("md")]: {
    ...typography["DM Serif H4"],
    mb: 3
  }
});
const sectionDescription = (theme) => ({
  ...typography["Lato Body 1"],
  mb: 10,
  [theme.breakpoints.down("md")]: {
    ...typography["Lato Body 2"],
    mb: 4
  }
});
const stepsContainer = (theme) => ({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: 6,
  mb: 6,
  [theme.breakpoints.down("md")]: {
    gap: 3,
    mb: 4
  }
});
const stepContainer = (theme) => ({
  maxWidth: "448px",
  boxSizing: "border-box",
  width: "100%",
  background: theme.palette.grey[100],
  p: 3,
  pb: 8,
  borderRadius: 3,
  [theme.breakpoints.down("md")]: {
    p: 2,
    pb: 4
  }
});
const imageContainer = (theme) => ({
  width: "100%",
  height: "auto",
  mb: 4,
  [theme.breakpoints.down("md")]: {
    mb: 3
  }
});
const stepTitle = (theme) => ({
  ...typography["Lato H4 Bold"],
  color: theme.palette.primary[800],
  mb: 2,
  [theme.breakpoints.down("md")]: {
    ...typography["Lato H5 Bold"],
    textAlign: "center"
  }
});
const stepDescription = (theme) => ({
  [theme.breakpoints.down("md")]: {}
});
export {
  container,
  imageContainer,
  root,
  sectionDescription,
  sectionTitle,
  stepContainer,
  stepDescription,
  stepTitle,
  stepsContainer
};
